import { colors } from '@lmc/common/constants'
import { EmptyState, NoDataIcon } from '@lmc/ui-kit'
import dayjs from 'dayjs'
import PropTypes from 'prop-types'
import { Component } from 'react'
import AnimateHeight from 'react-animate-height'
import { isBrowser, isTablet } from 'react-device-detect'
import { ProfilePicture, SeenByList } from '../../../../components/generic'
import HandoverPdfExport from '../../../../components/pdf/HandoverPdfExport'
import HandoverNotes from './HandoverNotes'
import HandoverResidentItem from './HandoverResidentItem'
import HandoverTitleBar from './HandoverTitleBar'

// TODO: the styles and layout in this file are a hot mess. it would be great to refactor and maybe restyle at some point

export default class HandoverHistoryItem extends Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    hasBeenOpened: false,
    isShowingContent: false
  }

  toggleContent = () => {
    if (!this.state.hasBeenOpened) this.props.onOpen()
    this.setState((prevState) => ({
      hasBeenOpened: true,
      isShowingContent: !prevState.isShowingContent
    }))
  }

  // eslint-disable-next-line class-methods-use-this
  renderCarer = (initialText, carer) => {
    return (
      <div style={styles.carer}>
        <span style={styles.name}>
          {initialText} {carer.name.first} {carer.name.last}
        </span>
        <ProfilePicture
          url={carer.picture}
          style={styles.carerImage}
          type="handover__small"
        />
      </div>
    )
  }

  renderHandoverCarers = () => {
    const { createdBy, witnessedBy } = this.props.handover
    if (!witnessedBy || !createdBy) return null
    return (
      <div style={styles.carersContainer}>
        {this.renderCarer('By', createdBy)}
        {this.renderCarer('to', witnessedBy)}
      </div>
    )
  }

  renderData = () => {
    const { createdOn, logsByResident, notes, seenBy } = this.props.handover
    if (!logsByResident || !notes) return null
    const isEmpty = !logsByResident.length && !notes.length
    const isDesktopStyles = isBrowser || isTablet

    if (isEmpty) {
      return <EmptyState title="Nothing to see here!" icon={<NoDataIcon />} />
    }
    return (
      <div
        style={{
          ...styles.dataContainer,
          flexDirection: isDesktopStyles ? 'row' : 'column'
        }}
      >
        {!isDesktopStyles && this.renderHandoverCarers()}
        <div style={isDesktopStyles ? styles.leftContainer : null}>
          {logsByResident.map((logGroup, i) => {
            return (
              <div key={i}>
                <HandoverResidentItem data={logGroup} />
              </div>
            )
          })}
        </div>
        <div style={isDesktopStyles ? styles.rightContainer : null}>
          {isBrowser && (
            <div style={styles.exportContainer}>
              <HandoverPdfExport
                title={`Handover - ${dayjs(createdOn).format('DD MMM YYYY')}`}
                handover={{ createdOn, logsByResident, notes }}
              />
            </div>
          )}
          <HandoverNotes notes={notes} />
          <div style={styles.seenByList}>
            <SeenByList seenBy={seenBy} />
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { createdOn, createdBy, logsByResident, notes, witnessedBy } =
      this.props.handover
    return (
      <div>
        <HandoverTitleBar
          createdOn={createdOn}
          createdBy={createdBy}
          witnessedBy={witnessedBy}
          onClick={this.toggleContent}
        />
        <AnimateHeight
          duration={500}
          height={
            this.state.isShowingContent && logsByResident && notes ? 'auto' : 0
          }
          animateOpacity
        >
          {this.renderData() || <div />}
        </AnimateHeight>
      </div>
    )
  }
}

const styles = {
  carer: {
    display: 'flex',
    flexDirection: 'row'
  },
  carerImage: {
    marginRight: 10
  },
  carersContainer: {
    display: 'flex',
    flexDirection: 'row',
    padding: '10px 0px 20px 0px',
    margin: '0 auto'
  },
  dataContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    borderBottom: `1px ${colors.grey} solid`,
    marginTop: 10,
    minHeight: 196,
    paddingBottom: 24
  },
  exportContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 10
  },
  leftContainer: {
    width: '60%',
    paddingRight: 20
  },
  name: {
    display: 'block',
    fontSize: 12,
    opacity: 0.8,
    padding: '10px 10px 0px 0px'
  },
  rightContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '40%',
    flex: '1'
  },
  seenByList: { marginTop: 24 }
}

HandoverHistoryItem.propTypes = {
  handover: PropTypes.object.isRequired,
  onOpen: PropTypes.func.isRequired
}
